import ReactModal from 'react-modal';

import './style/index.scss';
import App from './app';

ReactModal.setAppElement('body');

export default App;
